export default __webpack_public_path__ + "static/media/qrcode.fe5d1032.png";